module.exports = __webpack_public_path__ + "static/img/jxpxTitle.f597753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jxpxTitle.png
// module id = KCzN
// module chunks = 2